import { lazy, Suspense } from "react";
import { useLazyVisible } from "@/common/hooks/useLazyVisible";

const FooterLazy = lazy(
  () =>
    import(
      /* webpackChunkName: "footer", webpackPrefetch: true */ "@/widgets/Footer/ui/Footer"
    ),
);

export const Footer = () => {
  const { ref, isVisible } = useLazyVisible<HTMLDivElement>();
  return (
    <div ref={ref}>
      {isVisible && (
        <Suspense fallback={null}>
          <FooterLazy />
        </Suspense>
      )}
    </div>
  );
};
